/// <amd-module name="typeahead/features/FlightIconEnforcer" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [{
    lobs: ["PACKAGES"],
}];

export class FlightIconEnforcer implements ISuggestionsModifier {

    private static readonly FLIGHTS_ICON = "flights";
    private static readonly ORIGIN_FIELD_TYPE = "origin";

    public modifySuggestions(suggestions: any, context: IContext, options: any): JQueryPromise<Object[]> {
        let deferred: JQueryDeferred<Object[]> = $.Deferred();
        if (suggestions && suggestions.length > 0) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute) => {
                    if (shouldExecute && (this.isPackageOrigin())) {
                        suggestions.forEach((sugg): void => {
                            sugg.icon = FlightIconEnforcer.FLIGHTS_ICON;
                        });
                    }
                }).always(() => {
                    deferred.resolve(suggestions);
                });
        } else {
            deferred.resolve(suggestions);
        }
        return deferred.promise();
    }

    private isPackageOrigin(): boolean {
        return $("input:focus").data("gcw-storeable-name") &&
            $("input:focus").data("gcw-storeable-name").indexOf(FlightIconEnforcer.ORIGIN_FIELD_TYPE) > -1;
    }
}
